/**
 * Универсальный компонент пустого состояния
 * Иллюстрация + заголовок + описание + опциональное действие
 */

import type { ReactNode, CSSProperties } from 'react';

interface EmptyStateProps {
  /** URL иллюстрации */
  imageSrc: string;
  /** Заголовок */
  title: string;
  /** Описание (опционально) */
  description?: string;
  /** Действие — кнопка или любой ReactNode (опционально) */
  action?: ReactNode;
  /** Размер иллюстрации: 'default' = 224px, 'small' = 160px */
  imageSize?: 'default' | 'small';
  /** Дополнительные классы на контейнер */
  className?: string;
  /** Инлайн-стили на контейнер (например height: calc) */
  style?: CSSProperties;
}

const IMAGE_SIZE_MAP = {
  default: 'w-56 h-56',
  small: 'w-40 h-40',
} as const;

export function EmptyState({
  imageSrc,
  title,
  description,
  action,
  imageSize = 'default',
  className = '',
  style,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={`flex flex-col items-center justify-center px-6 ${className}`}
      style={style}
    >
      <img
        src={imageSrc}
        alt=""
        className={`${IMAGE_SIZE_MAP[imageSize]} mb-4 object-contain`}
        aria-hidden="true"
      />
      <h3 className="text-base font-semibold text-foreground text-center mb-1">
        {title}
      </h3>
      {description && (
        <p className="text-xs text-muted-foreground text-center max-w-xs">
          {description}
        </p>
      )}
      {action && (
        <div className="mt-8">
          {action}
        </div>
      )}
    </div>
  );
}
